import styled from 'styled-components';

export const EditMapContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: ${({ theme: { token } }) => token.paddingSM}px;
  position: absolute;
  top: 0;
  right: 0px;
  z-index: 2;
  gap: ${({ theme: { token } }) => token.padding}px;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  height: 100%;
  width: 100%;
  overflow: visible;

  .reset-zoom-btn {
    position: absolute;
    right: 3px;
    top: 20px;
    z-index: 1;
  }

  .spinner-container {
    text-align: center;
    padding-top: ${({ theme: { token } }) => token.paddingXL}px;

    .anticon-loading {
      font-size: ${({ theme: { token } }) => token.fontSizeHeading1}px;
    }
  }

  .diagram-cover {
    height: 100%;
    transition: 0.2s ease-in;
    position: relative;

    .diagram-container {
      height: 100%;
      min-height: 100%;

      > svg {
        overflow: visible;
      }
    }
  }

  .minimized-modal {
    width: 100%;
  }
`;

export const LoadingOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${({ theme: { token } }) => token.colorBgBase};
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
`;
